import { Injectable } from '@angular/core'
import { SwPush } from '@angular/service-worker'
import { env } from 'node:process'

@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {
  private readonly VAPID_PUBLIC_KEY =
    'BFEujE1aNTPMSQ9a52twlQBXl-9gvAn1PgRbRnOftGNFXQNfYaNIOVVwOeJ2GhvyV-y11PkbU7oWMHapPXP_cIs'

  constructor(private swPush: SwPush) {}

  requestSubscription() {
    if (this.swPush.isEnabled) {
      this.swPush
        .requestSubscription({
          serverPublicKey: this.VAPID_PUBLIC_KEY
        })
        .then(subscription => {
          console.log('Push Subscription:', subscription)
          // Send subscription to the backend to store it
        })
        .catch(err => console.error('Could not subscribe to notifications', err))
    }
  }
}
